module.exports = __webpack_public_path__ + "img/surat-list-penduduk-min.31e1fd4f.png";